<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-boxes" texto-titulo="Nuevo articulo"></TituloComponent>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <form @submit.prevent="guardarArticulo()">
          <div class="row">
            <FloatLabel label="Código" clase="col-md-6 col-12">
              <input
                v-model="articulo.codigo"
                id="codigo"
                inputmode="numeric"
                placeholder="Código"
                type="text"
                class="form-control"
              />
            </FloatLabel>
            <FloatLabel label="Descripción *" clase="col-md-6 col-12">
              <input
                v-model="articulo.descripcion"
                id="descripcion"
                placeholder="Descripción.."
                type="text"
                class="form-control"
                :class="(enviado && !$v.articulo.descripcion.required) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.descripcion.required"
                >Debe ingresar la descripción</div>
              </template>
            </FloatLabel>
            <float-label label="Precio compra:" clase="col-md-6 col-12" prepend="$">
              <input
                v-model="articulo.precio_compra"
                id="precio_compra"
                placeholder="0.00"
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.articulo.precio_compra.required || !$v.articulo.precio_compra.decimal)) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.precio_compra.required"
                >Debe ingresar el precio de compra</div>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.precio_compra.decimal"
                >Solo se aceptan números</div>
              </template>
            </float-label>
            <float-label label="Precio venta:" clase="col-md-6 col-12" prepend="$">
              <input
                v-model="articulo.precio_venta"
                id="precio_venta"
                placeholder="0.00"
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.articulo.precio_venta.required || !$v.articulo.precio_venta.decimal)) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.precio_venta.required"
                >Debe ingresar el precio de venta</div>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.precio_venta.decimal"
                >Solo se aceptan números</div>
              </template>
            </float-label>
            <FloatLabel label="Stock actual" clase=" col-md-6 col-12">
              <input
                v-model="articulo.stock"
                id="stock"
                placeholder="0.00"
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.articulo.stock.required || !$v.articulo.stock.decimal)) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.stock.required"
                >Debe ingresar el stock actual</div>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.stock.decimal"
                >Solo se aceptan números</div>
              </template>
            </FloatLabel>
            <float-label label="Stock mínimo:" clase="col-md-6 col-12">
              <input
                v-model="articulo.stock_minimo"
                id="stock_minimo"
                placeholder="0.00"
                type="number"
                step="0.01"
                class="form-control"
                :class="(enviado && (!$v.articulo.stock_minimo.required || !$v.articulo.stock_minimo.decimal)) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.stock_minimo.required"
                >Debe ingresar el stock mínimo</div>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.stock_minimo.decimal"
                >Solo se aceptan números</div>
              </template>
            </float-label>
            <float-label label="Marca:" clase="col-md-6 col-12">
              <select v-model="articulo.marca_id" id="marca_id" class="form-control" :class="(enviado && !$v.articulo.marca_id.required) ? 'is-invalid' : ''">
                <option value="null">Seleccione una opción</option>
                <option
                  v-for="marca in marcas"
                  :key="marca.id"
                  :value="marca.id"
                >{{marca.descripcion}}</option>
              </select>
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.marca_id.required"
                >Debe seleccionar la marca</div>
              </template>
            </float-label>
            <float-label label="Familia" clase="col-md-6 col-12">
              <select v-model="articulo.familia_id" id="familia_id" class="form-control" :class="(enviado && !$v.articulo.familia_id.required) ? 'is-invalid' : ''">
                <option value="null">Seleccione una opción</option>
                <option
                  v-for="familia in familias"
                  :key="familia.id"
                  :value="familia.id"
                >{{familia.descripcion}}</option>
              </select>
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.familia_id.required"
                >Debe seleccionar la familia</div>
              </template>
            </float-label>
            <float-label label="Alicuota:" clase="col-md-6 col-12" :class="(enviado && !$v.articulo.alicuota_iva_id.required) ? 'is-invalid' : ''">
              <select v-model="articulo.alicuota_iva_id" id="alicuota_iva_id" class="form-control">
                <option value="null">Seleccione una opción</option>
                <option
                  v-for="alicuota in alicuotas"
                  :key="alicuota.id"
                  :value="alicuota.id"
                >{{alicuota.descripcion}}</option>
              </select>
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.articulo.alicuota_iva_id.required"
                >Debe seleccionar la alicuota</div>
              </template>
            </float-label>
            <float-label label="Vista de impresión" clase="col-12">
              <wysiwyg v-model="articulo.vista_impresion" />
            </float-label>
          </div>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import { required, decimal } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Articulo from "@/models/articulo";
export default {
  name: "NuevoArticulo",
  components: {
    TituloComponent,
    FloatLabel,
    BlockUI
  },
  data() {
    return {
      articulo: new Articulo(
        null,
        null,
        "",
        null,
        null,
        null,
        null,
        null,
        null,
        5,
        null
      ),
      marcas: [],
      familias: [],
      alicuotas: [],
      loading: false,
      enviado: false
    };
  },
  validations: {
    articulo: {
      descripcion: { required },
      precio_compra: { required, decimal },
      precio_venta: { required, decimal },
      stock: { required, decimal },
      stock_minimo: { required, decimal },
      marca_id: { required },
      familia_id: { required },
      alicuota_iva_id: { required }
    }
  },
  watch: {
    'articulo.descripcion' : function(newVal, oldVal){
      if(this.articulo.vista_impresion == null || this.articulo.vista_impresion == oldVal){
        this.articulo.vista_impresion = this.articulo.descripcion
      }
    },
    'articulo.precio_compra': function(newVal){
      if(newVal != null && newVal != '' && !isNaN(newVal)){
        if(parseFloat(newVal) > 0){
          this.articulo.precio_venta = parseFloat((parseFloat(newVal)*1.15).toFixed(2));
        }else{
          this.articulo.precio_venta = 0;
        }
      }else{
          this.articulo.precio_venta = null;
      }
    }
  },
  mounted() {
    this.getMarcas();
    this.getFamilias();
    this.getAlicuotas();
  },
  methods: {
    guardarArticulo() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .post("/articulos", this.articulo)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.articulo.descripcion} se guardó con éxito.`
            });
            this.$router.push({ name: "ListarArticulos" });
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    },
    getMarcas() {
      axios.get("/marcas").then(res => {
        for (let marca of res.data.data) {
          this.marcas.push(marca);
        }
      });
    },
    getFamilias() {
      axios.get("/familias").then(res => {
        for (let familia of res.data.data) {
          this.familias.push(familia);
        }
      });
    },
    getAlicuotas() {
      axios.get("/alicuotas").then(res => {
        for (let alicuota of res.data.alicuotas) {
          console.log(alicuota);
          this.alicuotas.push(alicuota);
        }
      });
    }
  }
};
</script>
